import { Injectable } from '@angular/core';
import { ShoppingCartItem, UserPaymentIntent } from '../../models/shopping';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ShoppingApiService {
  constructor(private http: HttpService) {}
  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/shopping' + path, queryMap);
  }

  addShoppingCartItem({
    product_id,
    quantity,
    product_attr_value_ids,
    product_priced_attr_value_id,
  }: {
    product_id: number;
    quantity: number;
    product_attr_value_ids: number[];
    product_priced_attr_value_id: number;
  }): Promise<ShoppingCartItem> {
    const url = this.buildurl('/cart/item');
    return this.http.post(url, {
      product_id,
      quantity,
      product_attr_value_ids,
      product_priced_attr_value_id,
    });
  }
  setShoppingCartItem({
    product_id,
    quantity,
    product_attr_value_ids,
    product_priced_attr_value_id,
  }: {
    product_id: number;
    quantity: number;
    product_attr_value_ids: number[];
    product_priced_attr_value_id: number;
  }): Promise<ShoppingCartItem | null> {
    const url = this.buildurl('/cart/item');
    return this.http.put(url, {
      product_id,
      quantity,
      product_attr_value_ids,
      product_priced_attr_value_id,
    });
  }

  findShoppingCartItems(t?: number): Promise<ShoppingCartItem[]> {
    const url = this.buildurl('/cart/items', { t });
    return this.http.fget(url);
  }

  createPaymentIntent(): Promise<UserPaymentIntent> {
    const url = this.buildurl('/payment/intent');
    const body = {};
    return this.http.post(url, body);
  }

  getPaymentIntent(id: string): Promise<UserPaymentIntent> {
    const url = this.buildurl(`/payment/intent/${id}`);
    return this.http.fget(url);
  }

  confirmStripePaymentIntent(id: string): Promise<UserPaymentIntent> {
    const url = this.buildurl(`/stripe/payment/intent/${id}/confirm`);
    return this.http.fget(url);
  }
}
